import React from 'react';

function Hero() {
  return (
    <section id="hero" aria-label="Introduction">
      <div className="hero-content revealable">
        <h1>
          Abdulrahman Alamoudi
          <span>Strategic Finance & Investment Professional</span>
        </h1>
        <p>FP&A • M&A • Financial Modelling • Valuation • Event Studies • Portfolio & Risk Analysis</p>
        <p>Empowering bold decisions with insight-driven financial leadership.</p>
        <button className="btn-primary">
          <a href="#contact">Get in Touch</a>
        </button>
      </div>
    </section>
  );
}

export default Hero;